import { createClass as _createClass, classCallCheck as _classCallCheck, defineProperty as _defineProperty, typeof as _typeof } from '../_virtual/_rollupPluginBabelHelpers.js';

/* eslint-disable @typescript-eslint/no-explicit-any */
// https://github.com/ern0/kolorwheel.js 03/04/2020
// docs: http://linkbroker.hu/stuff/kolorwheel.js/
//
var KolorWheel = /*#__PURE__*/_createClass(function KolorWheel(_color) {
  var _this = this;
  _classCallCheck(this, KolorWheel);
  _defineProperty(this, "setColor", function (color) {
    if (typeof color == 'undefined') return;
    if (_typeof(color) == 'object') {
      _this.setHsl(color);
    } else {
      _this.setHex(color);
    }
  });
  // setColor()
  _defineProperty(this, "setHsl", function (hsl) {
    _this.h = hsl[0];
    _this.s = hsl[1];
    _this.l = hsl[2];
    _this.validateHsl();
    return _this;
  });
  // setHsl()
  _defineProperty(this, "validateHsl", function () {
    _this.h = _this.h % 360;
    if (_this.h < 0) _this.h += 360;
    if (_this.s < 0) _this.s = 0;
    if (_this.s > 100) _this.s = 100;
    if (_this.l < 0) _this.l = 0;
    if (_this.l > 100) _this.l = 100;
  });
  // validateHsl()
  _defineProperty(this, "setHex", function (hex) {
    if (hex.substring(0, 1) == '#') hex = hex.substring(1);
    var r = parseInt(hex.substring(0, 2), 16);
    var g = parseInt(hex.substring(2, 4), 16);
    var b = parseInt(hex.substring(4, 6), 16);
    _this.setRgb([r, g, b]);
    return _this;
  });
  // setHex()
  _defineProperty(this, "setRgb", function (rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    _this.h = (max + min) / 2;
    _this.s = _this.h;
    _this.l = _this.h;
    if (max == min) {
      // achromatic

      _this.h = 0;
      _this.s = 0;
    } else {
      var d = max - min;
      _this.s = _this.l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          _this.h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          _this.h = (b - r) / d + 2;
          break;
        case b:
          _this.h = (r - g) / d + 4;
          break;
      } // switch

      _this.h = _this.h / 6;
    } // else achromatic

    _this.h = 360 * _this.h;
    _this.s = 100 * _this.s;
    _this.l = 100 * _this.l;
    return _this;
  });
  // setRgb()
  _defineProperty(this, "hue2rgb", function (p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 1 / 2) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
  });
  // hue2rgb()
  _defineProperty(this, "getRgb", function () {
    _this.validateHsl();
    var h = _this.h / 360;
    var s = _this.s / 100;
    var l = _this.l / 100;
    var r = l;
    var g = l;
    var b = l;
    if (s != 0) {
      var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      var p = 2 * l - q;
      r = _this.hue2rgb(p, q, h + 1 / 3);
      g = _this.hue2rgb(p, q, h);
      b = _this.hue2rgb(p, q, h - 1 / 3);
    } // if not achromatic

    return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
  });
  // getRgb()
  _defineProperty(this, "getHex", function () {
    var result = _this.getRgb();
    var hex = _this.toHexByte(result[0]);
    hex += _this.toHexByte(result[1]);
    hex += _this.toHexByte(result[2]);
    return '#' + hex.toUpperCase();
  });
  // getHex()
  _defineProperty(this, "toHexByte", function (number) {
    var hexByte = number.toString(16);
    if (hexByte.length < 2) hexByte = '0' + hexByte;
    return hexByte;
  });
  // toHexByte()
  _defineProperty(this, "getHsl", function () {
    _this.validateHsl();
    return [_this.h, _this.s, _this.l];
  });
  // getHsl()
  _defineProperty(this, "multi", function (fn, p1, p2, p3, p4, p5) {
    var sourceList = [].concat(_this.resultList);
    _this.resultList = [];
    for (var i in sourceList) {
      var src = sourceList[i];
      src.workList = [];
      if (fn == 'rel') _this.spinSingle('rel', p1, p2, p3, p4, p5);
      if (fn == 'abs') _this.spinSingle('abs', p1, p2, p3, p4, p5);
      _this.resultList = _this.resultList.concat(src.workList);
    } // foreach sourceList

    if (_this.resultList.length == 0) return _this;
    var lastResult = _this.resultList[_this.resultList.length - 1];
    _this.h = lastResult.h;
    _this.s = lastResult.s;
    _this.l = lastResult.l;
    return _this;
  });
  // multi()
  _defineProperty(this, "rel", function (dh, ds, dl, length, start) {
    return _this.multi('rel', dh, ds, dl, length, start);
  });
  // rel()
  _defineProperty(this, "abs", function (dh, ds, dl, length, start) {
    var isDhAColor = false;
    if (_typeof(dh) == 'object') {
      if (typeof dh.validateHsl == 'function') isDhAColor = true;
    } else {
      if (('' + dh).substring(0, 1) == '#') isDhAColor = true;
      if (('' + dh).length > 4) isDhAColor = true;
    } // if dh is object

    if (isDhAColor) {
      var conv = new KolorWheel(dh);
      return _this.multi('abs', conv.h, conv.s, conv.l, ds, start);
    } else {
      return _this.multi('abs', dh, ds, dl, length, start);
    }
  });
  // abs()
  _defineProperty(this, "spinSingle", function (mode, dh, ds, dl, length, start) {
    var unchanged = mode == 'abs' ? -1 : 0;
    if (typeof dh == 'undefined') dh = unchanged;
    if (typeof ds == 'undefined') ds = unchanged;
    if (typeof dl == 'undefined') dl = unchanged;
    if (typeof dh == 'undefined') length = 12;
    var dhLength = 0;
    var dsLength = 0;
    var dlLength = 0;
    if (_typeof(dh) == 'object') dhLength = dh.length;
    if (_typeof(ds) == 'object') dsLength = ds.length;
    if (_typeof(dl) == 'object') dlLength = dl.length;
    if (typeof length == 'undefined') {
      length = 1;
      if (dhLength > length) length = dhLength;
      if (dsLength > length) length = dsLength;
      if (dlLength > length) length = dlLength;
    }
    if (typeof start == 'undefined') start = 0;
    var jquery = null;
    if (_typeof(length) == 'object') {
      jquery = length;
      length = jquery.length;
    }
    for (var step = start; step < length; step++) {
      var result = new KolorWheel(_this);
      var progress = length == 1 ? 1 : step / (length - 1);
      var parmh = void 0;
      var parms = void 0;
      var parml = void 0;
      if (dhLength > 0) {
        parmh = dh[step % dhLength];
      } else {
        parmh = dh * progress;
      }
      if (dsLength > 0) {
        parms = ds[step % dsLength];
      } else {
        parms = ds * progress;
      }
      if (dlLength > 0) {
        parml = dl[step % dlLength];
      } else {
        parml = dl * progress;
      }
      if (mode == 'rel') {
        result.h += parmh;
        result.s += parms;
        result.l += parml;
      } // if rel
      else {
        if (dh == unchanged) {
          result.h = _this.h;
        } else {
          if (dhLength == 0) {
            result.h = _this.calcLinearGradientStep(step, length, _this.h, dh);
          } else {
            result.h = parmh;
          }
        }
        if (ds == unchanged) {
          result.s = _this.s;
        } else {
          if (dsLength == 0) {
            result.s = _this.calcLinearGradientStep(step, length, _this.s, ds);
          } else {
            result.s = parms;
          }
        }
        if (dl == unchanged) {
          result.l = _this.l;
        } else {
          if (dlLength == 0) {
            result.l = _this.calcLinearGradientStep(step, length, _this.l, dl);
          } else {
            result.l = parml;
          }
        }
      } // else abs

      result.step = step;
      if (jquery) result.elm = jquery.eq(step);
      _this.workList[step] = result;
    } // for step
  });
  // spinSingle()
  _defineProperty(this, "calcLinearGradientStep", function (step, length, base, target) {
    var progress = step / (length - 1);
    var result = base + (target - base) * progress;
    return result;
  });
  // calcLinearGradientStep();
  _defineProperty(this, "each", function (fn) {
    for (var i in _this.resultList) {
      fn.call(_this.resultList[i], _this.resultList[i].elm);
    } // foreach result
  });
  // each()
  _defineProperty(this, "get", function (n) {
    if (typeof n == 'undefined') n = 0;
    return _this.resultList[n];
  });
  // get()
  _defineProperty(this, "isDark", function () {
    return !_this.isLight();
  });
  // isDark()
  _defineProperty(this, "isLight", function () {
    var rgb = _this.getRgb();
    var lum = 0.299 * rgb[0] + 0.587 * rgb[1] + 0.114 * rgb[2];
    return lum > 127;
  });
  this.resultList = [this];
  this.workList = [];
  this.elm = null;
  this.h = 0;
  this.s = 0;
  this.l = 0;
  this.step = 0;
  if (typeof _color == 'undefined') _color = '#001122';
  if (typeof _color.validateHsl == 'function') {
    this.setHsl([_color.h, _color.s, _color.l]);
  } else {
    this.setColor(_color);
  } // else clone
}

// isLight()
);

export default KolorWheel;
//# sourceMappingURL=kolor-wheel.esm.js.map
